﻿export default function () {
	const orders = document.querySelector('.orders');
	if (orders != null) {
		const orderItems = document.querySelectorAll('.orders__orderitem');
		if (orderItems != null) {
			orderItems.forEach(order => {
				const orderDetailsButton = order.querySelector('button[data-action=show-order]');
				const lineItems = order.querySelector('.orders__orderitem__lineitems');
				if (orderDetailsButton != null) {
					orderDetailsButton.addEventListener('click', function () {
						$(lineItems).slideToggle();
					});
				}

				const orderInvoiceForm = order.querySelector('form.orders__orderitem__invoice-form');
				if (orderInvoiceForm != null) {
					orderInvoiceForm.addEventListener('submit', async function (e) {
						e.preventDefault();
						const formData = new FormData(orderInvoiceForm);

						const response = await fetch(orderInvoiceForm.action, { method: orderInvoiceForm.method, body: formData});
						const data = await response.json();
						const html = data.html;

						const printWindow = window.open('', '', 'width=800,height=600');
						printWindow.document.write(html);
						printWindow.document.close();
						printWindow.focus();
						printWindow.print();
					});
				}
			});
		}
	}
}